export default __webpack_public_path__ + "static/media/header_bg.eee71809.png";